module.exports = __webpack_public_path__ + "media/src/assets/icons/podinbox_logo-2b33ed55d982826892e656e78c83898c.png";